var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "avatar-participation-status" },
    [
      _c("Avatar", {
        attrs: { "disable-tooltip": true, user: _vm.avatarLink }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "avatar-participation-status__indicator",
        class: _vm.className.class
      }),
      _vm._v(" "),
      _c("div", { staticClass: "avatar-participation-status__text" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.className.label) + "\n\t")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }